export var TypeActionTournament;
(function (TypeActionTournament) {
    TypeActionTournament["SelectTournamentDialog"] = "Tournament > SelectTournamentDialog";
    TypeActionTournament["GetPlayerLeagueRanking"] = "Tournament > UpdatePlayerLeagueRanking";
    TypeActionTournament["GetCoopLeagueRanking"] = "Tournament > UpdateCoopLeagueRanking";
    TypeActionTournament["GetCollectLeagueRanking"] = "Tournament > UpdateCollectLeagueRanking";
    TypeActionTournament["SetCurrentRewardInfo"] = "Tournament > SetCurrentRewardInfo";
    TypeActionTournament["RemoveCurrentRewardInfo"] = "Tournament > RemoveCurrentRewardInfo";
    TypeActionTournament["RequestPackageFromCurrentReward"] = "Tournament > RequestPackageFromCurrentReward";
    TypeActionTournament["LeagueRankingReceived"] = "Tournament > LeagueRankingReceived";
})(TypeActionTournament || (TypeActionTournament = {}));
export var actionSelectTournamentDialog = function () { return ({
    type: TypeActionTournament.SelectTournamentDialog,
}); };
export var actionGetCollectLeagueRanking = function () { return ({
    type: TypeActionTournament.GetCollectLeagueRanking,
}); };
export var actionGetCoopLeagueRanking = function (coopId, eventId, playerId) { return ({
    coopId: coopId,
    eventId: eventId,
    playerId: playerId,
    type: TypeActionTournament.GetCoopLeagueRanking,
}); };
export var actionGetPlayerLeagueRanking = function (eventId, playerId) { return ({
    eventId: eventId,
    playerId: playerId,
    type: TypeActionTournament.GetPlayerLeagueRanking,
}); };
export var actionRequestPackageFromCurrentReward = function () { return ({
    type: TypeActionTournament.RequestPackageFromCurrentReward,
}); };
export var actionSetCurrentRewardInfo = function (currentPackage, giftLevel, leagueGiftType, leagueId) { return ({
    currentPackage: currentPackage,
    giftLevel: giftLevel,
    leagueGiftType: leagueGiftType,
    leagueId: leagueId,
    type: TypeActionTournament.SetCurrentRewardInfo,
}); };
export var actionLeagueRankingReceived = function (response, leagueType) { return ({
    leagueType: leagueType,
    response: response,
    type: TypeActionTournament.LeagueRankingReceived,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/actionTournament.ts
// module id = 137
// module chunks = 3